import { Serializable } from '@admin/core/models/serializable';
import { PermissionModel } from '@admin/shared/models/permission-model';

export class AdminEditDataModel implements Serializable<AdminEditDataModel> {
  fromObject(object: any): AdminEditDataModel {
    Object.assign(this, object);

    this.permissions = [];

    if (
      object.permissions &&
      object.permissions.length &&
      object.permissions.length > 0
    ) {
      object.permissions.forEach((el) => {
        let t = new PermissionModel();
        t = t.fromObject(el);
        this.permissions.push(t);
      });
    }

    return this;
  }

  toObject() {
    return {
      AdminId: this.adminId,
      FullName: this.fullName,
      Email: this.email,
      MobileNumber: this.mobileNumber,
      Phone: this.phoneNumber,
      PhoneExtension: this.phoneExtension,
      Username: this.username,
      Password: this.password,
      Position: this.position,
      Permissions: this.permissions,
    };
  }

  public adminId: number;
  public fullName: string;
  public position: string;
  public email: string;
  public mobileNumber: string;
  public phoneNumber: string;
  public phoneExtension: string;
  public username: string;
  public password: string;
  public permissions: PermissionModel[];

  constructor() {
    this.permissions = [];
  }
}
